import React, { useContext } from "react";
import "./Footer.scss";
import { Link, Stack, Divider, Typography, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import TotalEnergiesContext from "../../../core/store/context/TotalEnergiesContext";
interface FooterProps {
  validUser: boolean;
}

const Footer: React.FC<FooterProps> = ({ validUser }) => {
  const { t } = useTranslation();
  const { isAgent } = useContext(TotalEnergiesContext);

  return (
    <footer className="App-Footer">
      <Container>
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          className="top-footer-stack"
        >
          <Stack direction="column" gap={"0.75rem"}>
            {validUser && (
              <>
                <span className="title brand-red">{t("Footer.Título")}</span>
                <div className="subtitle brand-gray">
                  <Typography
                    variant="body1"
                    className="brand-gray"
                    style={{ wordBreak: "break-word" }}
                  >
                    <span className="t-icon-mail brand-red icon" />
                    {t(`Footer.Email contacto${isAgent ? " agentes" : ""}`)}
                  </Typography>
                </div>
                {!isAgent && (
                  <div className="subtitle brand-gray">
                    <Typography variant="body1" className="brand-gray">
                      <span className="t-icon-phone brand-red icon" />
                      {t("Footer.Teléfono contacto")}
                    </Typography>
                  </div>
                )}
              </>
            )}
          </Stack>
          <Stack direction="column" gap={"0.75rem"}>
            <div className="brand-gray">
              <Typography variant="body1">
                {t("Footer.Nombre fiscal")}
              </Typography>
            </div>
            <div className="body1 brand-gray">
              <Typography variant="body1">{t("Footer.Dirección")}</Typography>
            </div>
          </Stack>
        </Stack>
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          className="bottom-footer-stack"
        >
          <Stack direction="row" gap={{ xs: "1rem", md: "1.5rem" }}>
            {validUser && (
              <>
                <div className="misc-text brand-gray">
                  <Link
                    variant="caption"
                    href="https://www.totalenergies.es/es/politica-de-cookies"
                    target="_blank"
                    className="brand-gray"
                  >
                    {t("Footer.Política cookies")}
                  </Link>
                </div>
                <Divider orientation="vertical" flexItem></Divider>
                <div className="misc-text brand-gray">
                  <Link
                    variant="caption"
                    href="https://www.totalenergies.es/es/informacion-legal"
                    target="_blank"
                    className="brand-gray"
                  >
                    {t("Footer.Aviso legal")}
                  </Link>
                </div>
                <Divider orientation="vertical" flexItem></Divider>
                <div className="misc-text brand-gray">
                  <Link
                    variant="caption"
                    href="https://www.totalenergies.es/es/politica-de-privacidad"
                    target="_blank"
                    className="brand-gray"
                  >
                    {t("Footer.Política privacidad")}
                  </Link>
                </div>
              </>
            )}
          </Stack>
          <Stack
            direction="column"
            alignItems="end"
            width={{ xs: "100%", md: "50%" }}
            gap={"0.75rem"}
          >
            <div className="copy-text brand-gray">
              <Typography variant="caption">
                {t("Footer.Creative commons")}
              </Typography>
            </div>
          </Stack>
        </Stack>
      </Container>
    </footer>
  );
};

export default Footer;
